module.exports = __webpack_public_path__ + "static/media/kudos-parent-icon.36afde56.svg";